import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Text } from '@/components/ui/text';
import { UserAvatar } from '@/components/ui/user-avatar';
import { useAuth } from '@/hooks/use-auth';
import { useCurrentUserProfile } from '@/hooks/use-profile';
import Ionicons from '@expo/vector-icons/Ionicons';
import { router } from 'expo-router';
import { Linking, View } from 'react-native';

export function TopBarProfileMenu() {
  const { user: authUser, logout } = useAuth();
  const { data: profileData } = useCurrentUserProfile();

  const user = profileData?.user || authUser;

  const handleLogout = async () => {
    await logout();
    router.replace('/(auth)/login');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <UserAvatar uri={user?.image} name={user?.name} size={32} />
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        <View className="px-2 py-1.5">
          <DropdownMenuLabel>{user?.name || 'User'}</DropdownMenuLabel>
          {user?.username && (
            <Text className="px-2 text-xs text-muted-foreground">
              @{user.username}
            </Text>
          )}
        </View>

        <DropdownMenuSeparator />

        <DropdownMenuItem
          icon={
            <Ionicons
              name="person-outline"
              size={18}
              className="text-muted-foreground"
            />
          }
          onPress={() => router.push('/(tabs)/profile')}
        >
          Profile
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem
          icon={
            <Ionicons
              name="settings-outline"
              size={18}
              className="text-muted-foreground"
            />
          }
          onPress={() => router.push('/(root)/settings')}
        >
          Settings
        </DropdownMenuItem>

        <DropdownMenuItem
          icon={
            <Ionicons
              name="flask-outline"
              size={18}
              className="text-muted-foreground"
            />
          }
          onPress={() => router.push('/(root)/alpha-program')}
        >
          Alpha Program
        </DropdownMenuItem>

        <DropdownMenuItem
          icon={
            <Ionicons
              name="logo-discord"
              size={18}
              className="text-muted-foreground"
            />
          }
          onPress={() => Linking.openURL('https://discord.gg/kmvXZsDx4y')}
        >
          Discord
        </DropdownMenuItem>

        {authUser?.role === 'admin' && (
          <DropdownMenuItem
            icon={
              <Ionicons
                name="shield-outline"
                size={18}
                className="text-muted-foreground"
              />
            }
            onPress={() => Linking.openURL('https://admin.flavrly.app')}
          >
            Admin
          </DropdownMenuItem>
        )}

        <DropdownMenuSeparator />

        <DropdownMenuItem
          destructive
          icon={
            <Ionicons
              name="log-out-outline"
              size={18}
              className="text-destructive"
            />
          }
          onPress={handleLogout}
        >
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
